document.addEventListener('DOMContentLoaded', function () {
    const tabsMembershipSwiperContainer = document.querySelector(".tabs-swiper");
    if (tabsMembershipSwiperContainer) {
        let swiperID = tabsMembershipSwiperContainer.id;
        const tabsMembershipSwiper = new Swiper(".tabs-swiper#" + swiperID, {
            speed: 400,
            spaceBetween: 30,
            slidesPerView: "auto",
            watchOverflow: true,
            slideToClickedSlide: true,
            grabCursor: true,
            slidesOffsetAfter: 30,
            breakpoints: {
                565: {
                    slidesPerView: 5,
                    spaceBetween: 40,
                    slidesOffsetAfter:15,
                    grabCursor: false,
                    slideToClickedSlide: false,

                }

            }
        });
    }


});